import React from "react";
import "./SuggestionSkeleton.css";

// Widths cycle so the placeholder rows look like varied real suggestions.
const BAR_WIDTHS = ["72%", "58%", "66%", "48%", "62%"];

/**
 * Row-shaped loading placeholder for suggestion dropdowns. Each row matches the
 * padding / height of a real suggestion row, so swapping real results in causes
 * no layout shift (CLS). Reuses the shimmer gradient look from
 * `shimmer/shimmer.css` for visual consistency across the app.
 *
 * @param {Object} props
 * @param {number} [props.rows]        number of placeholder rows (default 5)
 * @param {string} [props.className]   extra classes for the wrapper
 */
export default function SuggestionSkeleton({ rows = 5, className = "" }) {
  return (
    <div
      className={`suggestion-skeleton ${className}`.trim()}
      role="status"
      aria-busy="true"
      aria-live="polite"
    >
      {Array.from({ length: rows }).map((_, index) => (
        <div key={index} className="suggestion-skeleton__row">
          <span
            className="suggestion-skeleton__bar"
            style={{ width: BAR_WIDTHS[index % BAR_WIDTHS.length] }}
          />
        </div>
      ))}
      <span className="suggestion-skeleton__sr">Loading suggestions…</span>
    </div>
  );
}
